var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomationResult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Automation_result",
    "data-name": "Automation result",
    transform: "translate(0 -198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wand-magic-sparkles-solid",
    d: "M9.05,1.646,7.6,2.19a.3.3,0,0,0,0,.555l1.454.544.544,1.454a.3.3,0,0,0,.555,0l.544-1.454,1.454-.544a.3.3,0,0,0,0-.555l-1.454-.544L10.148.193a.3.3,0,0,0-.555,0Zm-7.272,13.6a1.855,1.855,0,0,0,0,2.618L3.112,19.2a1.855,1.855,0,0,0,2.618,0l14.7-14.706a1.855,1.855,0,0,0,0-2.618L19.1.544a1.855,1.855,0,0,0-2.618,0ZM18.685,3.185,14.637,7.234l-.9-.9,4.049-4.049.9.9ZM.289,4.519a.444.444,0,0,0,0,.833l2.179.817.817,2.179a.444.444,0,0,0,.833,0l.817-2.179,2.179-.817a.444.444,0,0,0,0-.833L4.935,3.7,4.118,1.523a.444.444,0,0,0-.833,0L2.468,3.7ZM13.862,14.39a.444.444,0,0,0,0,.833l2.179.817.817,2.179a.444.444,0,0,0,.833,0l.817-2.179,2.179-.817a.444.444,0,0,0,0-.833l-2.179-.817-.817-2.179a.444.444,0,0,0-.833,0l-.817,2.179Z",
    transform: "translate(14.14 213.068)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomationResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AutomationResult.d1fcdb16900442dc0b2ba6bc589533a3.svg";